var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      attrs: {
        id: _vm.gtmEventId,
        disabled: _vm.isDisabled,
        type: _vm.buttonType,
      },
      on: { click: _vm.onClick },
    },
    [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }